import { useParams } from 'react-router'

export const useBlock = () => {
  const { block } = useParams<{
    block: string
  }>()

  if (!block) {
    throw new Error('No block ID was found')
  }

  return block
}
